import { useSearchContext } from "../../context/search";
import { StyledNav } from "../../styles/StyledNav";
import Logo from "../Logo/Logo";
import { Search } from "../Search";
import NavMenu from "./NavMenu";

export default function Nav() {
	const { dispatch } = useSearchContext();

	const setPhrase = (phrase) => {
		localStorage.setItem("search", phrase);
		dispatch({ type: "SET_PHRASE", payload: { phrase } });
	};

	return (
		<StyledNav>
			<Logo />
			<Search advancedSearch={true} setPhrase={setPhrase} />
			<NavMenu />
		</StyledNav>
	);
}
